import script from "./xianxiazuoyexiangqing.vue?vue&type=script&setup=true&lang=js"
export * from "./xianxiazuoyexiangqing.vue?vue&type=script&setup=true&lang=js"

import "./xianxiazuoyexiangqing.vue?vue&type=style&index=0&id=62e03556&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62e03556"]])

export default __exports__